export class WiapiImageInsertTracker {
	constructor() {
		this.data = null;

		this.start = Date.now();

		window.addEventListener('beforeunload', (_event) => {
			if (this.data !== null && window.newrelic) {
				window.newrelic.addPageAction('wiapiImageInsert', this.data);
			}
		});
	}

	onImageLoad(modalOpen, modalIndex, carouselIndex) {
		if (
			!this.data ||
			(modalOpen && this.data.imageLoadedWithModalOpen === false)
		) {
			const insertTime = Date.now();
			this.data = {
				imageLoadedWithModalOpen: modalOpen,
				modalIndex,
				carouselIndex,
				elapsed: insertTime - this.start,
				insertTime
			};
		}
	}
}
